import { FunctionService } from '@aa/angular/core';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'aa-admin-jobs-view',
  standalone: true,
  imports: [MatButtonModule],
  templateUrl: './admin-jobs-view.component.html',
  styleUrl: './admin-jobs-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminJobsViewComponent {
  private functionService = inject(FunctionService);

  async setupCalender() {
    const { url } = await firstValueFrom(
      this.functionService.getCalenderSetupURL(),
    );

    window.open(url, '_blank');
  }
}
